import client from '../request'

const getAll = `/users`

const get = (id) => {
  return `/users/${id}`
}

const create = (data) => {
  return client.post('/users', data)
}

const update = (id, data) => {
  return client.put(`/users/${id}`, data)
}

const changePassword = (data) => {
  return client.post(`/users/change-password`, data)
}

const toRow = (data) => {
  if (data?.data?.length > 0) {
    return data.data.map((element) => {
      return {
        ...element,
        key: element.id
      }
    })
  }

  return []
}

const toRowWithoutChildren = (data) => {
  if (data?.data?.length > 0) {
    return data.data.map(({ children, ...element }) => {
      return {
        ...element,
        key: element.id
      }
    })
  }

  return []
}

const toPaginate = (data) => {
  return {
    total: data?.meta?.total ?? 0
  }
}

const UserService = {
  getAll,
  get,
  create,
  update,
  changePassword,
  toRow,
  toRowWithoutChildren,
  toPaginate
}

export default UserService
